import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';

const testimonials = [
    {
        image: <img src="/assets/images/svg/scrollhomeimage.svg" alt="Rachael Schumm" width="74px" />,
        name: "Rachael Schumm",
        position: "CTO, Deloitte",
        quote: "Molestias ut tenetur eos placeat aliquam.",
        content: "The 3D product renders brought our concepts to life with stunning accuracy and detail. They’ve elevated our product presentations to a whole new level of professionalism."
    },
    {
        image: <img src="/assets/images/svg/scrollhomeimage.svg" alt="John Doe" width="74px" />,
        name: "John Doe",
        position: "CEO, Company",
        quote: "Aliquam quaerat cumque.",
        content: "The T-shirt designs are a brilliant blend of creativity and style, capturing our brand's identity perfectly. Our customers can’t get enough of these standout pieces!"
    },
    {
        image: <img src="/assets/images/svg/scrollhomeimage.svg" alt="Jane Smith" width="74px" />,
        name: "Jane Smith",
        position: "COO, Business",
        quote: "Eos placeat aliquam.",
        content: "The logo designed by the team perfectly captures the essence of our brand—modern, precise, and professional. It's a true reflection of Machtig's expertise in pins and small machine parts trading."
    },
    {
        image: <img src="/assets/images/svg/scrollhomeimage.svg" alt="Another Jane Smith" width="74px" />,
        name: "Another Jane Smith",
        position: "COO, Business",
        quote: "Eos placeat aliquam.",
        content: "The website design combines functionality with sleek aesthetics, making it effortless for our clients to explore our offerings. A perfect representation of our precision in machine tooling and metal parts services."
    },
];

const Card = () => {

    const bg = useColorModeValue('red.500', 'red.200')
    const color = useColorModeValue('#FFFFF', 'white')

    const [currentIndex, setCurrentIndex] = useState(0);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const { image, name, position, quote, content } = testimonials[currentIndex];

    return (
        <Box position="relative" width="100%" px={{ base: "10px", md: "20px" }}>
            {/* Fixed Card (Testimonial) */}
            <Box
                position="absolute"
                top={{ base: "43%", md: "54%" }} 
                left={{md:"30%",base:"50%"}}
                transform="translate(-50%, -50%)"
                width={{ base: "94%", md: "30%" }} 
                height={{ base: "60%", md: "100%" }}
                zIndex="2"
                p={4}
                bg="#FFCCCC" 
                borderWidth="2px"
                borderRadius="10px"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                overflow="hidden"
            >
                {/* Testimonial Text */}
                <Box>
                    <Text fontSize={{ base: "16px", md: "18px" }} fontWeight="bold" mb={2} color="black">
                        "{quote}"
                    </Text>
                    <Text fontSize={{ base: "12px", md: "14px" }} fontFamily="'Gilroy-Bold', sans-serif" color="black">
                        {content}
                    </Text>
                </Box>

                {/* Profile Information */}
                <Flex align="center" mt={4}>
                    {image}
                    <Box ml={3}>
                        <Text fontWeight="bold" fontSize={{ base: "20px", md: "30px" }} color="#FE3A3A">
                            {name}
                        </Text>
                        <Text fontSize={{ base: "16px", md: "24px" }} color="#1C1C1C">
                            {position}
                        </Text>
                    </Box>
                </Flex>
            </Box>

            {/* Scrolling Images Container - adjusted margin-top for mobile */}
            <Box
                width={{ base: "100%", md: "100%" }}
                height={{ base: "110px", md: "240px" }} 
                overflow="hidden"
                zIndex="1"
                mt={{ base: "380px", md: "300px" }} 
            >
                <Flex
                    width="100%"
                    height="100%"
                    whiteSpace="nowrap"
                    style={{ animation: 'scroll 40s linear infinite' }}
                >
                    <img src="/assets/images/svg/scrollhomeimage.svg" alt="Scroll Image 1" width="auto" style={{ borderRadius: '10px', margin: '0 10px' }} />
                    <img src="/assets/images/svg/scrollhomeimage.svg" alt="Scroll Image 2" width="auto" style={{ borderRadius: '10px', margin: '0 10px' }} />
                    <img src="/assets/images/svg/scrollhomeimage.svg" alt="Scroll Image 3" width="auto" style={{ borderRadius: '10px', margin: '0 10px' }} />
                    <img src="/assets/images/svg/scrollhomeimage.svg" alt="Scroll Image 4" width="auto" style={{ borderRadius: '10px', margin: '0 10px' }} />
                </Flex>
            </Box>

            {/* CSS for scrolling animation */}
            <style>{`
                @keyframes scroll {
                    0% { transform: translateX(100%); }
                    100% { transform: translateX(-100%); }
                }
            `}</style>
        </Box>
    );
};

export default Card;
